import AxiosInstance from 'utils/AxiosInstance'
import * as types from './types'
import {
  SYSTEM_SETUP_CANDIDATE_CATEGORY,
  SYSTEM_SETUP_JOB_CATEGORY,
  SYSTEM_SETUP_JOB_STAGE,
  SYSTEM_SETUP_OFFER_LETTER_SETTINGS,
  SYSTEM_SETUP_SALARY_TYPE,
  SYSTEM_SETUP_SCREEN_INDICATOR,
  SYSTEM_SETUP_SCREENING_TYPE,
} from './reducer'
import { v4 as uuidv4 } from 'uuid'
import { isTextEmpty } from 'utils/helpers'
import { toast } from 'react-toastify'

const getSystemSetupField = (activeSystemSetupSidebarRoute) => {
  switch (activeSystemSetupSidebarRoute) {
    case SYSTEM_SETUP_JOB_CATEGORY:
      return 'job_categories'

    case SYSTEM_SETUP_JOB_STAGE:
      return 'job_stage'

    case SYSTEM_SETUP_SALARY_TYPE:
      return 'salary_type'

    case SYSTEM_SETUP_CANDIDATE_CATEGORY:
      return 'candidate_category'

    case SYSTEM_SETUP_SCREENING_TYPE:
      return 'screening_type'

    case SYSTEM_SETUP_SCREEN_INDICATOR:
      return 'screen_indicator'

    case SYSTEM_SETUP_OFFER_LETTER_SETTINGS:
      return 'offer_letter_settings'

    default:
      return 'job_categories'
  }
}

export const setAreYouSureModalData = (payload) => ({
  type: types.SET_SHOW_ARE_YOU_SURE_MODAL,
  payload,
})

export const setShowAlertModal = (payload) => ({
  type: types.SET_SHOW_ALERT_MODAL,
  payload,
})

export const setCreateJobSlide = (payload) => ({
  type: types.SET_CREATE_JOB_SLIDE,
  payload,
})

export const setSystemSidebarRoute = (payload) => ({
  type: types.SET_ACTIVE_SYSTEM_SETUP_SIDEBAR_ROUTE,
  payload,
})

export const setCurrentSetupSystemRawData = (payload) => ({
  type: types.SET_CURRENT_SYSTEM_SETUP_DATA,
  payload,
})

export const setJobDetailRoute = (payload) => ({
  type: types.SET_JOB_DETAIL_ROUTE,
  payload,
})

export const setApplicationDetailRoute = (payload) => ({
  type: types.SET_APPLICATION_DETAIL_ROUTE,
  payload,
})

export const setApplication = (payload) => ({
  type: types.SET_JOB_APPLICATION,
  payload,
})

export const setCurrentSetupSystemData = (payload, editingArray = false) => {
  return (dispatch, getState) => {
    const { editingSystemSetup, currentSystemSetupData } =
      getState().recruitment

    const generalIdExists = Boolean(payload.generalId) || Array.isArray(payload)

    let updatedArray = []
    if (generalIdExists) {
      if (editingArray) {
        updatedArray = payload
      } else {
        const currentArray = Array.isArray(currentSystemSetupData)
          ? currentSystemSetupData
          : []

        updatedArray = currentArray.filter(
          (item) => item.field !== payload.field
        )

        updatedArray.push({
          id: !editingSystemSetup ? uuidv4() : payload.id || uuidv4(),
          ...payload,
        })
      }

      dispatch({
        type: types.SET_CURRENT_SYSTEM_SETUP_DATA,
        payload: updatedArray,
      })
    } else {
      const existingId = payload?.id || currentSystemSetupData?.id

      dispatch({
        type: types.SET_CURRENT_SYSTEM_SETUP_DATA,
        payload: {
          id: !editingSystemSetup ? uuidv4() : existingId,
          ...payload,
        },
      })
    }
  }
}

export const resetSetupSystemData = () => ({
  type: types.RESET_SYSTEM_SETUP_DATA,
})

export const setCurrentSetupSystemRows = (payload) => ({
  type: types.SET_CURRENT_SYSTEM_SETUP_ROWS,
  payload,
})

export const setSystemSetupModal = (payload) => ({
  type: types.SET_SYSTEM_SETUP_CREATE_EDIT_MODAL,
  payload,
})

export const setEditingSystemSetup = (payload) => ({
  type: types.SET_SYSTEM_SETUP_EDITING,
  payload,
})

export const setFormSubmitted = (payload) => ({
  type: types.SET_FORM_SUBMITTED,
  payload,
})

export const onChangeOfferLetter = (value) => async (dispatch) => {
  dispatch({ type: types.SET_OFFER_LETTER, payload: value })
}

export const updateSetup = (customFn, editData = null) => {
  return (dispatch, getState) => {
    if (editData?.action !== 'delete') {
      dispatch(setFormSubmitted(true))
    }

    const { activeSystemSetupSidebarRoute, currentSystemSetupData } =
      getState().recruitment
    let canSubmit = true

    if (
      editData?.action !== 'delete' &&
      typeof currentSystemSetupData === 'object'
    ) {
      if (
        !Object.keys(currentSystemSetupData).length ||
        (currentSystemSetupData.required && !currentSystemSetupData.value)
      )
        canSubmit = false
    }

    if (!canSubmit) return

    let field = getSystemSetupField(activeSystemSetupSidebarRoute)

    console.log(field, currentSystemSetupData, editData, 'leart180')

    AxiosInstance.put('/recruitment/setup', {
      field,
      data: [currentSystemSetupData],
      editData,
    }).then(() => {
      if (customFn) {
        customFn()
      }
      dispatch(getSystemSetup())
    })
  }
}

export const updateOfferLetter = () => {
  return (dispatch, getState) => {
    const { offerLetterText, activeSystemSetupSidebarRoute } =
      getState().recruitment

    if (isTextEmpty(offerLetterText)) return

    let field = getSystemSetupField(activeSystemSetupSidebarRoute)

    AxiosInstance.put('/recruitment/setup', {
      field,
      data: offerLetterText,
      editData: null,
    })
  }
}

export const updateJobStageOrder = () => {
  return (dispatch, getState) => {
    const { currentSystemSetupRows } = getState().recruitment

    AxiosInstance.put('/recruitment/setup', {
      field: 'job_stage',
      data: currentSystemSetupRows,
      editData: { action: 'reorder' },
    })
  }
}

export const getSystemSetup = (resourceId = null, manualField = '') => {
  return (dispatch, getState) => {
    const { activeSystemSetupSidebarRoute, offerLetterText } =
      getState().recruitment

    let field = getSystemSetupField(activeSystemSetupSidebarRoute)
    if (manualField) field = manualField

    AxiosInstance.get(
      `/recruitment/setup/${field}${resourceId ? `/${resourceId}` : ''}`
    ).then((data) => {
      if (!resourceId) {
        if (field === 'offer_letter_settings' && !offerLetterText) {
          dispatch(onChangeOfferLetter(data?.at(0)?.offer_letter_settings))
          return
        }
        dispatch(
          setCurrentSetupSystemRows(
            data?.length
              ? data.map((element) => {
                  if (Array.isArray(element)) {
                    return element.reduce((acc, item) => {
                      acc[item.field] = item.value

                      if (item.field === 'name') {
                        acc.generalId = item.generalId
                      }

                      return acc
                    }, {})
                  } else {
                    if (field === 'job_stage') {
                      return {
                        [element.field]: element.value,
                        id: element.id,
                        hired_stage: element?.hired_stage,
                        interview_stage: element?.interview_stage,
                      }
                    } else {
                      return { [element.field]: element.value, id: element.id }
                    }
                  }
                })
              : []
          )
        )
      } else {
        dispatch(setCurrentSetupSystemData(data, Boolean(data?.length)))
      }
    })
  }
}

export const createJobScreening = (data) => {
  return (dispatch, getState) => {
    AxiosInstance.post('/recruitment/job-screening', data).then(() => {
      dispatch(getJobScreenings())
    })
  }
}

export const updateJobScreening = (id, data) => {
  return (dispatch, getState) => {
    AxiosInstance.put(`/recruitment/job-screening/${id}`, data).then(() => {
      dispatch(getJobScreenings())
    })
  }
}

export const getJobScreenings = () => {
  return (dispatch, getState) => {
    AxiosInstance.get('/recruitment/job-screening').then((data) => {
      dispatch({ type: types.SET_JOB_SCREENINGS, payload: data })
    })
  }
}

export const deleteJobScreening = (id) => {
  return (dispatch, getState) => {
    AxiosInstance.delete(`/recruitment/job-screening/${id}`).then(() => {
      dispatch(getJobScreenings())
    })
  }
}

export const setJobProp = (payload) => {
  return (dispatch, getState) => {
    const { jobProps } = getState().recruitment

    let finalResult = []

    if (!jobProps.find((job) => job.name === payload.name)) {
      finalResult = [...jobProps, payload]
    } else {
      finalResult = jobProps.map((job) =>
        job.name === payload.name ? payload : job
      )
    }

    dispatch({ type: types.SET_JOB_PROPS, payload: finalResult })
  }
}

export const setAllJobProps = (payload) => {
  return (dispatch, getState) => {
    const res = []
    for (const [key, value] of Object.entries(payload)) {
      let obj = { name: key, value }
      if (key === 'skills' && typeof value === 'string') {
        const skills = JSON.parse(value)
        const valueSkills = skills.map((skill) => {
          return { id: skill, name: skill, option: { name: skill } }
        })
        obj = { name: key, value: valueSkills }
      }

      if (key === 'custom_questions') {
        const customQuestions = JSON?.parse(value)?.map((val) => +val)
        obj = { name: key, value: customQuestions }
      }
      res.push(obj)
    }

    dispatch({ type: types.SET_JOB_PROPS, payload: res })
  }
}

export const resetJobProps = () => ({ type: types.RESET_JOB_PROPS })

export const getSkills = () => {
  return (dispatch, getState) => {
    AxiosInstance.get('/recruitment/skills').then((data) => {
      dispatch({ type: types.SET_SKILLS, payload: data })
    })
  }
}

export const createSkill = (skill, onCreated) => {
  return (dispatch) => {
    const data = { name: skill?.at(0)?.value }

    AxiosInstance.post('/recruitment/skills', data).then((res) => {
      const created = { label: data.name, value: data.name }

      if (onCreated) onCreated(created)

      dispatch(getSkills())
    })
  }
}

export const getJobs = (id = null) => {
  return (dispatch, getState) => {
    const url = !id ? `/recruitment/jobs` : `/recruitment/jobs/${id}`
    AxiosInstance.get(url).then((data) => {
      if (id) {
        dispatch(setAiInterviewConclusion(data?.at(0)?.conclusion))
        dispatch(setAiInterviewIntroduction(data?.at(0)?.introduction))
        dispatch(setStopInterviewOnTabChange(data?.at(0)?.end_on_tab_change))
        if (data?.at(0)?.aiQuestions?.length) {
          dispatch(setAiQuestions(data?.at(0)?.aiQuestions))
        }

        let newData = data?.at(0)

        delete newData.conclusion
        delete newData.introduction
        delete newData.end_on_tab_change
        delete newData.aiQuestions

        dispatch(setAllJobProps(newData))
      } else {
        dispatch({ type: types.SET_JOBS, payload: data })
      }
    })
  }
}

export const createJob = (successFn, id = null) => {
  const requiredFields = [
    'title',
    'status',
    'location',
    'positions',
    'salary_from',
    'salary_to',
    'start_date',
    'end_date',
    'job_type',
    'category_id',
    'recruitment_type',
    'branch',
    'skills',
    'description',
    'requirements',
  ]

  return (dispatch, getState) => {
    dispatch(setFormSubmitted(true))

    const {
      jobProps,
      aiInterviewConclusion,
      aiInterviewIntroduction,
      stopInterviewOnTabChange,
      aiQuestions,
    } = getState().recruitment

    const filledFields = jobProps.map((el) => el.name)

    const allRequiredFieldsFilled = requiredFields.every((field) =>
      filledFields.includes(field)
    )

    if (!allRequiredFieldsFilled) {
      dispatch(
        setShowAlertModal({
          show: true,
          text: 'Please fill all the required fields.',
        })
      )
      return
    }

    for (const { name, value } of jobProps) {
      if (!requiredFields.includes(name)) continue

      const isInvalid =
        value === undefined ||
        (typeof value === 'string' && value.trim().length === 0) ||
        (Array.isArray(value) && value.length === 0) ||
        (['description', 'requirements'].includes(name) &&
          typeof value === 'string' &&
          isTextEmpty(value))

      if (isInvalid) {
        dispatch(
          setShowAlertModal({
            show: true,
            text: 'Please fill all the required fields.',
          })
        )
        return
      }
    }

    const data = {
      jobProps,
      aiInterviewConclusion,
      aiInterviewIntroduction,
      end_on_tab_change: stopInterviewOnTabChange ? 1 : 0,
      aiQuestions,
    }

    if (!id) {
      AxiosInstance.post('/recruitment/jobs', data).then(() => {
        dispatch(setFormSubmitted(false))
        successFn()
      })
    } else {
      AxiosInstance.put(`/recruitment/jobs/${id}`, data).then(() => {
        dispatch(setFormSubmitted(false))
        successFn()
      })
    }
  }
}

export const updateJobPublicationStatus = (id, status) => {
  return (dispatch, getState) => {
    AxiosInstance.put(`/recruitment/jobs/publication-status/${id}`, {
      status,
    }).then(() => {
      dispatch(getJobs(id))
    })
  }
}

export const deleteJob = (id) => {
  return (dispatch) => {
    AxiosInstance.delete(`/recruitment/jobs/${id}`).then(() => {
      dispatch(getJobs())
    })
  }
}

export const setCreatingApplication = (payload) => ({
  type: types.SET_CREATING_APPLICATION,
  payload,
})

export const createJobApplication = (data, jobId) => {
  return (dispatch, getState) => {
    dispatch(setCreatingApplication(true))
    return AxiosInstance.post(`/recruitment/job/applications`, data)
      .then((response) => {
        dispatch(getJobApplications(jobId))

        if (response.status !== 409) {
          dispatch({
            type: types.SET_JOB_TRACKING_ID,
            payload: response,
          })
          dispatch({ type: types.SET_ERROR_MESSAGE, payload: '' })
          return { success: true }
        } else {
          dispatch({
            type: types.SET_ERROR_MESSAGE,
            payload: response.error,
          })
          return { success: false, error: response.error }
        }
      })
      .catch((error) => {
        dispatch({
          type: types.SET_ERROR_MESSAGE,
          payload: error.message || 'An error occurred',
        })
        return { success: false, error: error.message }
      })
      .finally(() => {
        dispatch(setCreatingApplication(false))
      })
  }
}

export const getJobApplications = (jobId) => {
  return (dispatch, getState) => {
    AxiosInstance.get(`/recruitment/job/applications/${jobId}`).then((data) =>
      dispatch({ type: types.SET_JOB_APPLICATIONS, payload: data })
    )
  }
}

export const getJobApplicationsWithReviews = (jobId) => {
  return (dispatch, getState) => {
    AxiosInstance.get(`/recruitment/ai-applications/${jobId}`).then((data) =>
      dispatch({ type: types.SET_JOB_APPLICATIONS, payload: data })
    )
  }
}

export const getApplication = (id) => {
  return (dispatch, getState) => {
    AxiosInstance.get(`/recruitment/job/application/${id}`).then((data) =>
      dispatch(setApplication(data))
    )
  }
}

export const deleteApplication = (applicationId, jobId) => {
  return (dispatch, getState) => {
    AxiosInstance.delete(`/recruitment/job/application/${applicationId}`).then(
      (data) => dispatch(getJobApplications(jobId))
    )
  }
}

export const updateJobApplication = (id, data) => {
  return (dispatch, getState) => {
    AxiosInstance.put(`/recruitment/job/application/${id}`, data).then(() => {
      dispatch(getApplication(id))

      if (window.location.pathname === '/job-application') {
        dispatch(setAllJobApplicationsAndJobs())
      }

      if (window.location.pathname === '/job/interview-schedule') {
        dispatch(getScheduledInterviews())
      }
    })
  }
}

export const getArchivedJobs = () => {
  return (dispatch, getState) => {
    AxiosInstance.get(`/recruitment/archived/jobs`).then((data) => {
      dispatch({ type: types.SET_ARCHIVED_JOBS, payload: data })
    })
  }
}

export const getOnboardJobs = () => {
  return (dispatch) => {
    AxiosInstance.get(`/recruitment/onboard`).then((data) => {
      dispatch({ type: types.SET_ONBOARDINGG_JOBS, payload: data })
    })
  }
}

export const addToJobOnboard = (data) => {
  return (dispatch) => {
    AxiosInstance.post(`/recruitment/onboard`, data).then(() => {
      dispatch(getApplication(data?.application_id))

      if (window.location.pathname === '/job-application') {
        dispatch(setAllJobApplicationsAndJobs())
      }

      if (window.location.pathname === '/job/interview-schedule') {
        dispatch(getScheduledInterviews())
      }

      if (window.location.pathname === '/job-onboard') {
        dispatch(getOnboardJobs())
      }
    })
  }
}

export const deleteOnboardingJob = (id) => {
  return (dispatch) => {
    AxiosInstance.delete(`/recruitment/onboard/${id}`).then(() => {
      dispatch(getOnboardJobs())
    })
  }
}

export const updateOnboardingJob = (id, data) => {
  return (dispatch) => {
    AxiosInstance.put(`/recruitment/onboard/${id}`, data).then(() => {
      dispatch(getOnboardJobs())
    })
  }
}

export const getScheduledInterviews = (applicationId = null) => {
  return (dispatch) => {
    const url = !applicationId
      ? '/recruitment/interviews'
      : `/recruitment/interviews/${applicationId}`

    AxiosInstance.get(url).then((data) => {
      dispatch({ type: types.SET_INTERVIEWS, payload: data })
    })
  }
}

export const createInterviewSchedule = (data) => {
  return (dispatch) => {
    AxiosInstance.post(`/recruitment/interviews`, data).then(() => {
      dispatch(getScheduledInterviews(data?.application_id))

      dispatch(getApplication(data?.application_id))

      if (window.location.pathname === '/job-application') {
        dispatch(setAllJobApplicationsAndJobs())
      }
    })
  }
}

export const updateInterview = (id, data, query = null) => {
  return (dispatch) => {
    AxiosInstance.put(
      `/recruitment/interviews/${id}${query ? query : ''}`,
      data
    ).then(() => {
      dispatch(getScheduledInterviews())
    })
  }
}

export const deleteInterview = (id) => {
  return (dispatch) => {
    AxiosInstance.delete(`/recruitment/interviews/${id}`).then(() => {
      dispatch(getScheduledInterviews())
    })
  }
}

export const getApplicationNotes = (id) => {
  return (dispatch) => {
    AxiosInstance.get(`/recruitment/application/notes/${id}`).then((data) => {
      dispatch({ type: types.SET_APPLICATION_NOTES, payload: data })
    })
  }
}

export const createApplicationNotes = (data) => {
  return (dispatch) => {
    AxiosInstance.post(`/recruitment/application/notes`, data).then(() => {
      dispatch(getApplicationNotes(data?.application_id))
    })
  }
}

export const deleteApplicationNote = (noteId, applicationId) => {
  return (dispatch) => {
    AxiosInstance.delete(`/recruitment/application/notes/${noteId}`).then(
      () => {
        dispatch(getApplicationNotes(applicationId))
      }
    )
  }
}

export const updateApplicationNote = (noteId, applicationId, data) => {
  return (dispatch) => {
    AxiosInstance.put(`/recruitment/application/notes/${noteId}`, data).then(
      () => {
        dispatch(getApplicationNotes(applicationId))
      }
    )
  }
}

export const getApplicationTodos = (id) => {
  return (dispatch) => {
    AxiosInstance.get(`/recruitment/todo/application/${id}`).then((data) => {
      dispatch({ type: types.SET_APPLICATION_TODO, payload: data })
    })
  }
}

export const createApplicationTodo = (data) => {
  return (dispatch) => {
    AxiosInstance.post(`/recruitment/todo/application`, data).then(() => {
      dispatch(getApplicationTodos(data?.application_id))
    })
  }
}

export const deleteApplicationTodo = (todoId, applicationId) => {
  return (dispatch) => {
    AxiosInstance.delete(`/recruitment/todo/application/${todoId}`).then(() => {
      dispatch(getApplicationTodos(applicationId))
    })
  }
}

export const updateApplicationTodo = (todoId, applicationId, data) => {
  return (dispatch) => {
    AxiosInstance.put(`/recruitment/todo/application/${todoId}`, data).then(
      () => {
        dispatch(getApplicationTodos(applicationId))
      }
    )
  }
}

export const setAllJobApplicationsAndJobs = () => {
  return (dispatch) => {
    AxiosInstance.get(`/recruitment/all/job/applications`).then((data) => {
      dispatch({ type: types.SET_ALL_APPLICATIONS, payload: data })
    })
  }
}

export const setFilterStartDate = (payload) => ({
  type: types.SET_FILTER_START_DATE,
  payload,
})

export const setFilterEndDate = (payload) => ({
  type: types.SET_FILTER_END_DATE,
  payload,
})

export const setFilterJobStage = (payload) => ({
  type: types.SET_FILTER_JOB_STAGE,
  payload,
})

export const setFilterJob = (payload) => ({
  type: types.SET_FILTER_JOB,
  payload,
})

export const resetApplicationFilters = () => ({
  type: types.RESET_APPLICATION_FILTERS,
})

export const getCareerJobs = (id = null) => {
  return (dispatch) => {
    const url = !id
      ? `/recruitment/career/jobs`
      : `/recruitment/career/jobs/${id}`

    AxiosInstance.get(url).then((data) => {
      dispatch({ type: types.SET_CAREER_JOBS, payload: data })
    })
  }
}

export const trackApplication = (payload) => {
  return (dispatch) => {
    AxiosInstance.post(`/recruitment/career/track/application`, payload).then(
      (data) => {
        dispatch({
          type: types.SET_TRACKING_RESULT,
          payload: data
            ? data
            : { error: 'These credentials do not match our records.' },
        })
      }
    )
  }
}

export const getTrackedApplication = (payload) => {
  return (dispatch) => {
    AxiosInstance.post(`/recruitment/career/tracked/application`, payload).then(
      (data) => {
        dispatch(setApplication(data))
      }
    )
  }
}

export const getOfferLetterData = (applicationId) => {
  return (dispatch) => {
    AxiosInstance.get(`/recruitment/offer-letter/${applicationId}`).then(
      (data) => dispatch({ type: types.SET_OFFER_LETTER_DATA, payload: data })
    )
  }
}

export const sendOfferLetter = (payload) => {
  return (dispatch) => {
    AxiosInstance.post(`/recruitment/offer-letter`, payload).then(() => {
      toast.success(`Offer email has been sent.`, {
        position: toast.POSITION.TOP_CENTER,
        className: 'general-settings-toast',
        autoClose: 2500,
      })
    })
  }
}

export const archiveMultipleApplications = (ids, archive = 1) => {
  return (dispatch, getState) => {
    const { jobApplications } = getState().recruitment

    AxiosInstance.put(`/recruitment/archive/applications`, {
      ids,
      archive,
    }).then(() => {
      const newApplications = jobApplications.map((el) => {
        return ids.includes(el.id) ? { ...el, archived: archive } : el
      })

      dispatch({ type: types.SET_JOB_APPLICATIONS, payload: newApplications })
    })
  }
}

export const deleteMultipleApplications = (ids) => {
  return (dispatch, getState) => {
    const { jobApplications } = getState().recruitment

    AxiosInstance.put(`/recruitment/delete/applications`, { ids }).then(() => {
      dispatch({
        type: types.SET_JOB_APPLICATIONS,
        payload: jobApplications.filter((el) => !ids.includes(el.id)),
      })
    })
  }
}

export const updateMultipleApplicationsStage = (ids, stage) => {
  return (dispatch, getState) => {
    const { jobApplications } = getState().recruitment

    AxiosInstance.put(`/recruitment/update/applications/stage`, {
      ids,
      stage,
    }).then(() => {
      const newApplications = jobApplications.map((el) => {
        return ids.includes(el.id) ? { ...el, job_stage: stage } : el
      })

      dispatch({ type: types.SET_JOB_APPLICATIONS, payload: newApplications })
    })
  }
}

export const createMultipleInterviews = (data, successFn = () => {}) => {
  return (dispatch, getState) => {
    AxiosInstance.post(
      '/recruitment/create/multiple/interviews',
      Object.entries(data).map((el) => {
        return {
          application_id: el[0],
          employee_id: el[1].selectedAdmins.option.id,
          date: el[1].interviewDate,
          time: el[1].interviewTime,
          end_time: el[1].endInterviewTime,
          meeting_info: el[1]?.meetingInfo ?? '',
          comment: el[1]?.comment ?? '',
        }
      })
    ).then(() => {
      successFn()
    })
  }
}

export const createMultipleOnBoard = (data, successFn = () => {}) => {
  return (dispatch, getState) => {
    AxiosInstance.post(
      '/recruitment/create/multiple/onboard',
      Object.entries(data).map((el) => {
        return {
          application_id: el[0],
          joining_date: el[1].joiningDate,
          days_of_week: el[1].daysOfWeek,
          salary: el[1].salary,
          salary_duration: el[1]?.salaryDuration?.option?.value,
          salary_type: el[1]?.salaryType?.option?.id,
          status: el[1]?.status?.option?.value,
        }
      })
    ).then(() => {
      successFn()
    })
  }
}

export const reviewWithAi = (jobId) => {
  return (dispatch) => {
    dispatch({ type: types.SET_REVIEWING_APPLICATIONS, payload: true })
    AxiosInstance.get(`/recruitment/ai-filter/${jobId}`).then(() => {
      dispatch({ type: types.SET_REVIEWING_APPLICATIONS, payload: false })
      dispatch(getJobApplicationsWithReviews(jobId))
    })
  }
}

export const getAiInterviewRankings = (jobId) => {
  return (dispatch) => {
    AxiosInstance.get(`/recruitment/ai-interview/rankings/${jobId}`).then(
      (data) =>
        dispatch({ type: types.SET_AI_INTERVIEW_RANKINGS, payload: data })
    )
  }
}

export const getAppeals = (jobId) => {
  return (dispatch) => {
    AxiosInstance.get(`/recruitment/interviews/appeals/${jobId}`).then((data) =>
      dispatch({ type: types.SET_APPEALS, payload: data })
    )
  }
}

export const resetAiInterviewState = (interviewId, jobId) => {
  return (dispatch) => {
    AxiosInstance.delete(
      `/recruitment/ai-interview/reset-state/${interviewId}`
    ).then(() => dispatch(getAiInterviewRankings(jobId)))
  }
}

export const setAiInterviewIntroduction = (payload) => ({
  type: types.SET_AI_INTERVIEW_INTRODUCTION,
  payload,
})

export const setAiInterviewConclusion = (payload) => ({
  type: types.SET_AI_INTERVIEW_CONCLUSION,
  payload,
})

export const setStopInterviewOnTabChange = (payload) => ({
  type: types.SET_STOP_INTERVIEW_ON_TAB_CHANGE,
  payload,
})

export const setAiQuestions = (payload) => ({
  type: types.SET_AI_INTERVIEW_QUESTIONS,
  payload,
})

export const resetAiInterviewSetup = () => ({
  type: types.RESET_AI_INTERVIEW_SETUP,
})
